import React, { useState, useEffect } from 'react';
import './AddDrawer.css';
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import closeIcon from "../../assets/images/closeIcon.svg";
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import BodyExtraSmallRegular from '../designSystem/BodyExtraSmallRegular';
import tickIcon from "../../assets/images/tickIcon.svg";
import AddEventCard from './AddEventCard';
import deleteIcon_drawer from "../../assets/images/deleteIcon_drawer.svg";
import addIcon from "../../assets/images/addIcon.svg";
import { useDispatch, useSelector } from 'react-redux';
import { getTaskPracticeLocations, getTaskLookup } from '../../actions/userActions/tasks/taskAction';
import { addEmployeePlan, deletePlanVisits, updateEmployeePlan } from '../../actions/userActions/EmployeePlanAction';
import { getVisitProfileDetail } from '../../actions/userActions/VisitProfileAction';
import { getEmployee } from '../../actions/userActions/employeeAction';
import DeleteVisitModal from './DeleteVisitModal';
import { getCities } from '../../actions/userActions/cityAction';
import SingleSelect from '../designSystem/SingleSelect';
import VisitProfileModal from './VisitProfileModal';
import Textarea from '../designSystem/TextArea';
import Heading6Regular from '../designSystem/Heading6Regular';
import BodySmallMedium from '../designSystem/BodySmallMedium';
import { t } from '../../locales/translate';
import LoadingOverlay from '../loadingOverlay/LoadingOverlay'
import visitProfileIcon from "../../assets/images/visitprofile.svg";

const AddDrawer = ({ isOpen, onClose, day, events }) => {
    const permissions = JSON.parse(localStorage.getItem('permissionsList'));
    const [isDeleteVisitModalVisible, setIsDeleteVisitModalVisisble] = useState(false);
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.result[0]?.user.id;
    const dispatch = useDispatch();
    const [isVisitProfileId, setIsVisitProfileId] = useState(false);
    const [disable, setDisable] = useState(false);
    const [visitProfileId, setVisitProfileId] = useState(null);
    const [errors, setErrors] = useState([]);
    const [deletePlanDetail, setDeletePlanDetail] = useState([]);
    const [deletePlanVisitsIds, setDeletePlanVisitsIds] = useState([]);
    const [updatedFormValues, setUpdatedFormValues] = useState();
    const [isVisitProfileModalVisible, setIsVisitProfileModalVisible] = useState(false);
    const [VisitProfileChange, setVisitProfileChange] = useState(null);
    const [isPracticeLocationsLoading, setIsPracticeLocationsLoading] = useState(false);
    const practiceLocations = useSelector(state => state.tasks_reducer.taskPracticeLocations);
    const addPlanStatus = useSelector(state => state.employeePlan_reducer.addEmployeePlan);
    const updateEmployeePlanStatus = useSelector(state => state.employeePlan_reducer.updateEmployeePlan);
    const deletePlanVisitsStatus = useSelector(state => state.employeePlan_reducer.deletePlanVisits);
    const visitProfileDetail = useSelector(state => state.visitProfile_reducer.visitProfileDetail);
    const userDetail = useSelector((state) => state.employees_reducer.employee);
    
    const initialValues = {
    employeePlanId: 0,
    employeeId: userId,
    month: null,
    year: null,
    employeePlanDates: [] 
}
    const [isDeleteActive, setIsDeleteActive] = useState(false);
const [formValues, setFormValues] = useState(initialValues);
const [isSaving, setIsSaving] = useState(false);
const [visitProfilePlanDetails, setVisitProfilePlanDetails] = useState({}); 
const [isLoadingVisitProfile, setIsLoadingVisitProfile] = useState(false); 
const [loadedVisitProfiles, setLoadedVisitProfiles] = useState(new Set()); 
const [activeVisitProfileId, setActiveVisitProfileId] = useState(null);
const taskLookups = useSelector((state) => state.taskLookupReducer.taskLookups);
const taskLookupsLoading = useSelector((state) => state.taskLookupReducer.taskLookupLoading);
   const handleOnLeaveChange = (e) => {
    const isChecked = e.target.checked;
    
    setFormValues((prevValues) => ({
        ...prevValues,
        employeePlanDates: prevValues.employeePlanDates.map(planDate => ({
            ...planDate,
            onLeave: isChecked,  // Update ALL visit profiles
            leaveMessage: isChecked ? planDate.leaveMessage : "",
            // When unchecking onLeave, add an empty plan detail if none exist
            planDetails: !isChecked && planDate.planDetails.length === 0
                ? [{
                    id: 0,
                    cityId: null,
                    startTime: null,
                    endTime: null,
                    practiceLocationId: null,
                    doctorId: null,
                    headOffice: false
                }]
                : planDate.planDetails
        }))
    }));
    
    setDisable(false);
    setErrors([]);
};

    // NEW CODE:
const handleLeaveMessageChange = (e) => {
    const value = e.target.value;
    
    if (value.length > 150) {
        return;
    }
    
    if (!isVisitProfileId) {
        // No visit profiles - update the first (only) plan date
        setFormValues((prevValues) => ({
            ...prevValues,
            employeePlanDates: [{
                ...prevValues.employeePlanDates[0],
                leaveMessage: value
            }]
        }));
    } else {
        // With visit profiles
        setFormValues((prevValues) => ({
            ...prevValues,
            employeePlanDates: prevValues.employeePlanDates.map(planDate => 
                planDate.visitProfileId === activeVisitProfileId
                    ? { ...planDate, leaveMessage: value }
                    : planDate
            )
        }));
    }
    
    if (value.length === 150) {
        setErrors([{
            ...errors[0],
            leaveMessage: "Message cannot exceed 150 characters"
        }]);
    } else if (errors[0]?.leaveMessage) {
        setErrors([{
            ...errors[0],
            leaveMessage: ''
        }]);
    }
};
    // NEW CODE:
const addAnotherPlanDetail = () => {
    const activePlanDate = getActivePlanDate();
    if (activePlanDate?.onLeave) return;

    const newPlanDetail = permissions && permissions.includes('CanAddPlannerTime') && permissions.includes('CanAddPlannerCity')
        ? {
    id: 0,
    cityId: user?.result[0]?.user?.cityId,
    startTime: null,
    endTime: null,
    practiceLocationId: null,
    doctorId: null,
    headOffice: false,
    products: [],
    subTasks: [],
    priority: null,
    accompaniedByIds: []
}
        
        : {
            id: 0,
            cityId: isVisitProfileId
                ? (visitProfileDetail?.result?.[0]?.cityId || null)
                : (user?.result[0]?.user?.cityId || null),
            startTime: null,
            endTime: null,
            practiceLocationId: null,
            doctorId: null,
            headOffice: false
        };

    if (!isVisitProfileId) {
        // No visit profiles - update the first (only) plan date
        setFormValues((prevValues) => ({
            ...prevValues,
            employeePlanDates: [{
                ...prevValues.employeePlanDates[0],
                planDetails: [...prevValues.employeePlanDates[0].planDetails, newPlanDetail]
            }]
        }));
    } else {
        // With visit profiles
        setFormValues((prevValues) => ({
            ...prevValues,
            employeePlanDates: prevValues.employeePlanDates.map(planDate => 
                planDate.visitProfileId === activeVisitProfileId
                    ? {
                        ...planDate,
                        planDetails: [...planDate.planDetails, newPlanDetail]
                    }
                    : planDate
            )
        }));
    }
    setDisable(false);
};

    // NEW CODE:
useEffect(() => {
    if (day && userDetail && userDetail !== "isLoading" && !events) {
        const formattedDate = new Date(day.year, day.month - 1, day.day + 1).toISOString();
        
        // Check if user has visit profiles
        if (userDetail.visitProfiles && userDetail.visitProfiles.length > 0) {
            // User HAS visit profiles
            const initialPlanDates = userDetail.visitProfiles.map(profile => ({
                employeePlanDateId: 0,
                planDate: formattedDate,
                visitProfileId: profile.visitProfileId,
                onLeave: false,
                leaveMessage: "",
                planDetails: permissions && permissions.includes('CanAddPlannerTime') && permissions.includes('CanAddPlannerCity')
                    ? [{
    id: 0,
    cityId: user?.result[0]?.user?.cityId,
    startTime: null,
    endTime: null,
    practiceLocationId: null,
    doctorId: null,
    headOffice: false,
    products: [],
    subTasks: [],
    priority: null,
    accompaniedByIds: []
}]
                    : [{
    id: 0,
    cityId: user?.result[0]?.user?.cityId,
    startTime: null,
    endTime: null,
    practiceLocationId: null,
    doctorId: null,
    headOffice: false,
    products: [],
    subTasks: [],
    priority: null,
    accompaniedByIds: []
}]
            }));

            setFormValues((prevValues) => ({
                ...prevValues,
                month: day.month,
                year: day.year,
                employeePlanDates: initialPlanDates
            }));
            
            if (userDetail.visitProfiles.length > 0) {
                setActiveVisitProfileId(userDetail.visitProfiles[0].visitProfileId);
            }
            
            setIsVisitProfileId(true);
        } else {
            // User does NOT have visit profiles - use single plan date without visitProfileId
            const initialPlanDate = {
                employeePlanDateId: 0,
                planDate: formattedDate,
                visitProfileId: null,
                onLeave: false,
                leaveMessage: "",
                planDetails: permissions && permissions.includes('CanAddPlannerTime') && permissions.includes('CanAddPlannerCity')
                    ? [{
    id: 0,
    cityId: user?.result[0]?.user?.cityId,
    startTime: null,
    endTime: null,
    practiceLocationId: null,
    doctorId: null,
    headOffice: false,
    products: [],
    subTasks: [],
    priority: null,
    accompaniedByIds: []
}]
                    : [{
                        id: 0,
                        cityId: user?.result[0]?.user?.cityId || null,
                        startTime: null,
                        endTime: null,
                        practiceLocationId: null,
                        doctorId: null,
                        headOffice: false
                    }]
            };

            setFormValues((prevValues) => ({
                ...prevValues,
                month: day.month,
                year: day.year,
                employeePlanDates: [initialPlanDate]
            }));
            
            setActiveVisitProfileId(null);
            setIsVisitProfileId(false);
        }
        
        setDisable(false);
    }
}, [day, userDetail]);

  // NEW CODE:
useEffect(() => {
    if (isOpen && events && userDetail && userDetail !== "isLoading") {
        let employeePlanDatesArray = [];
        let employeePlanId = 0;
        
        if (Array.isArray(events)) {
            employeePlanDatesArray = events;
            employeePlanId = events[0]?.employeePlanId || 0;
        } else if (events && typeof events === 'object') {
            employeePlanDatesArray = events.employeePlanDates || [];
            employeePlanId = events.employeePlanId || events.id || 0;
        }
        
        if (employeePlanDatesArray.length === 0) {
            console.warn('No employeePlanDates found in events:', events);
            return;
        }
        
        const formattedPlanDates = employeePlanDatesArray.flatMap(event => {
            // Handle ON LEAVE case specially
            if (event.onLeave) {
                // When on leave
                if (userDetail.visitProfiles && userDetail.visitProfiles.length > 0) {
                    // Create entries for ALL user's visit profiles with the SAME employeePlanDateId
                    return userDetail.visitProfiles.map(profile => ({
                        employeePlanDateId: event.id || 0,
                        planDate: event.planDate,
                        visitProfileId: profile.visitProfileId,
                        onLeave: true,
                        leaveMessage: event.leaveMessage || "",
                        planDetails: []
                    }));
                } else {
                    // No visit profiles - single entry
                    return [{
                        employeePlanDateId: event.id || 0,
                        planDate: event.planDate,
                        visitProfileId: null,
                        onLeave: true,
                        leaveMessage: event.leaveMessage || "",
                        planDetails: []
                    }];
                }
            }
            
            // NEW STRUCTURE: Check if this event has visitProfiles array (multiple visit profiles)
            if (event.visitProfiles && event.visitProfiles.length > 0) {
                return event.visitProfiles.map(vp => ({
                    employeePlanDateId: event.id || 0,
                    planDate: event.planDate,
                    visitProfileId: vp.visitProfileId,
                    onLeave: false,
                    leaveMessage: "",
                    planDetails: vp.planDetails && vp.planDetails.length > 0
                        ? vp.planDetails.map((detail) => ({
                            id: detail.id || 0,
                            cityId: detail.cityId || null,
                            startTime: detail.startTime || null,
                            endTime: detail.endTime || null,
                            practiceLocationId: detail.practiceLocationId || null,
                            doctorId: detail.doctorId || null,
                            headOffice: Boolean(detail.headOffice),
                            products: Array.isArray(detail.products)
                                ? detail.products.map(p => typeof p === 'object' ? p.productId : p)
                                : [],
                            subTasks: Array.isArray(detail.subTasks)
                                ? detail.subTasks.map(s => typeof s === 'object' ? s.subTaskId : s)
                                : [],
                            priority: detail.priority || null,
                            accompaniedByIds: Array.isArray(detail.accompaniedBy)
                                ? detail.accompaniedBy.map(a => typeof a === 'object' ? a.accompaniedBy : a)
                                : (Array.isArray(detail.accompaniedByIds) ? detail.accompaniedByIds : [])
                        }))
                        : []
                }));
            } 
            // OLD STRUCTURE: Single visitProfile (legacy) OR no visit profiles
            else if (event.visitProfile && event.visitProfile.visitProfileId) {
                return [{
                    employeePlanDateId: event.id || 0,
                    planDate: event.planDate,
                    visitProfileId: event.visitProfile.visitProfileId,
                    onLeave: false,
                    leaveMessage: "",
                    planDetails: event.planDetails && event.planDetails.length > 0
                        ? event.planDetails.map((detail) => ({
                            id: detail.id || 0,
                            cityId: detail.cityId || null,
                            startTime: detail.startTime || null,
                            endTime: detail.endTime || null,
                            practiceLocationId: detail.practiceLocationId || null,
                            doctorId: detail.doctorId || null,
                            headOffice: Boolean(detail.headOffice),
                            products: Array.isArray(detail.products)
                                ? detail.products.map(p => typeof p === 'object' ? p.productId : p)
                                : [],
                            subTasks: Array.isArray(detail.subTasks)
                                ? detail.subTasks.map(s => typeof s === 'object' ? s.subTaskId : s)
                                : [],
                            priority: detail.priority || null,
                            accompaniedByIds: Array.isArray(detail.accompaniedBy)
                                ? detail.accompaniedBy.map(a => typeof a === 'object' ? a.accompaniedBy : a)
                                : (Array.isArray(detail.accompaniedByIds) ? detail.accompaniedByIds : [])
                        }))
                        : []
                }];
            }
            // NO VISIT PROFILES: Use direct planDetails
            else {
                return [{
                    employeePlanDateId: event.id || 0,
                    planDate: event.planDate,
                    visitProfileId: null,
                    onLeave: false,
                    leaveMessage: "",
                    planDetails: event.planDetails && event.planDetails.length > 0
                        ? event.planDetails.map((detail) => ({
                            id: detail.id || 0,
                            cityId: detail.cityId || null,
                            startTime: detail.startTime || null,
                            endTime: detail.endTime || null,
                            practiceLocationId: detail.practiceLocationId || null,
                            doctorId: detail.doctorId || null,
                            headOffice: Boolean(detail.headOffice),
                            products: Array.isArray(detail.products)
                                ? detail.products.map(p => typeof p === 'object' ? p.productId : p)
                                : [],
                            subTasks: Array.isArray(detail.subTasks)
                                ? detail.subTasks.map(s => typeof s === 'object' ? s.subTaskId : s)
                                : [],
                            priority: detail.priority || null,
                            accompaniedByIds: Array.isArray(detail.accompaniedBy)
                                ? detail.accompaniedBy.map(a => typeof a === 'object' ? a.accompaniedBy : a)
                                : (Array.isArray(detail.accompaniedByIds) ? detail.accompaniedByIds : [])
                        }))
                        : []
                }];
            }
        });

        // Fill in missing visit profiles with empty data (ONLY if user has visit profiles)
        let completePlanDates;
        
        if (userDetail.visitProfiles && userDetail.visitProfiles.length > 0) {
            const allVisitProfiles = userDetail.visitProfiles;

            completePlanDates = allVisitProfiles.map(profile => {
                const existingPlanDate = formattedPlanDates.find(
                    pd => pd.visitProfileId === profile.visitProfileId
                );
                
                if (existingPlanDate) {
                    return existingPlanDate;
                } else {
                    const formattedDate = new Date(day.year, day.month - 1, day.day + 1).toISOString();
                    return {
                        employeePlanDateId: 0,
                        planDate: formattedDate,
                        visitProfileId: profile.visitProfileId,
                        onLeave: false,
                        leaveMessage: "",
                        planDetails: [{
                            id: 0,
                            cityId: null,
                            startTime: null,
                            endTime: null,
                            practiceLocationId: null,
                            doctorId: null,
                            headOffice: false
                        }]
                    };
                }
            });
        } else {
            // No visit profiles - use formattedPlanDates as is
            completePlanDates = formattedPlanDates;
        }

        const firstPlanDateWithData = formattedPlanDates.find(pd => pd.visitProfileId);
        let initialActiveVisitProfileId = null;

        if (firstPlanDateWithData && firstPlanDateWithData.visitProfileId) {
            initialActiveVisitProfileId = firstPlanDateWithData.visitProfileId;
            const loadedProfileIds = formattedPlanDates
                .filter(pd => pd.visitProfileId)
                .map(pd => pd.visitProfileId);
            setLoadedVisitProfiles(new Set(loadedProfileIds));
            setIsVisitProfileId(true);
        } else if (completePlanDates.length > 0 && completePlanDates[0].visitProfileId) {
            initialActiveVisitProfileId = completePlanDates[0].visitProfileId;
            setIsVisitProfileId(true);
        } else {
            // No visit profiles
            setIsVisitProfileId(false);
        }

        setActiveVisitProfileId(initialActiveVisitProfileId);
        setVisitProfileId(initialActiveVisitProfileId);

        setFormValues({
            employeePlanId: employeePlanId,
            employeeId: userId,
            month: day.month,
            year: day.year,
            employeePlanDates: completePlanDates
        });

        setDisable(false);
        setIsLoadingVisitProfile(false);
    }
}, [events, day, isOpen, userDetail, userId]);useEffect(() => {
    if (isOpen && !events && userDetail && userDetail !== "isLoading" && userDetail.visitProfiles && userDetail.visitProfiles.length > 0) {
        const firstVisitProfile = userDetail.visitProfiles[0];
        
        if (!activeVisitProfileId) {
            setIsLoadingVisitProfile(true);
            setVisitProfileId(firstVisitProfile.visitProfileId);
            setActiveVisitProfileId(firstVisitProfile.visitProfileId);
            setIsVisitProfileId(true);
            
            dispatch(getVisitProfileDetail(firstVisitProfile.visitProfileId));
        }
    }
}, [isOpen, events, userDetail, activeVisitProfileId]);

    const formattedDate = day
        ? new Intl.DateTimeFormat('en-US', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        }).format(new Date(day.year, day.month - 1, day.day))
        : '';

    useEffect(() => {
    if (user && user.result[0]?.user) {
        if (visitProfileId && isVisitProfileId) {
            dispatch(getVisitProfileDetail(visitProfileId));
        } else if (!isVisitProfileId) {
            if (!permissions.includes('CanViewPlannerCity') || 
                (permissions.includes('CanAddPlannerCity') && permissions.includes('CanAddPlannerLocation'))) {
                setIsPracticeLocationsLoading(true);
                dispatch(getTaskPracticeLocations(user.result[0].user.cityId));
            }
        }
    }
}, [userId, dispatch, isVisitProfileId, visitProfileId]);

// When visitProfileDetail loads for a NEW plan (type 3 users), backfill the cityId
// from the visit profile so it's saved correctly. Editing existing plans already have
// the cityId from the backend, so we only do this when there are no events.
useEffect(() => {
    if (
        !events &&
        isVisitProfileId &&
        visitProfileId &&
        visitProfileDetail &&
        visitProfileDetail !== "isLoading" &&
        visitProfileDetail.result &&
        visitProfileDetail.result.length > 0
    ) {
        const profileCityId = visitProfileDetail.result[0]?.cityId;
        if (profileCityId) {
            setFormValues(prevValues => ({
                ...prevValues,
                employeePlanDates: prevValues.employeePlanDates.map(planDate => {
                    if (planDate.visitProfileId === visitProfileId) {
                        return {
                            ...planDate,
                            planDetails: planDate.planDetails.map(detail => ({
                                ...detail,
                                cityId: profileCityId
                            }))
                        };
                    }
                    return planDate;
                })
            }));
        }
    }
}, [visitProfileDetail]);

useEffect(() => {
    if (practiceLocations && practiceLocations !== "isLoading") {
        setIsPracticeLocationsLoading(false);
    }
}, [practiceLocations]);
    // NEW CODE:
const updatePlanDetail = (index, updatedDetail) => {
    if (!isVisitProfileId) {
        // No visit profiles - update the first (only) plan date
        setFormValues((prevValues) => ({
            ...prevValues,
            employeePlanDates: [{
                ...prevValues.employeePlanDates[0],
                planDetails: prevValues.employeePlanDates[0].planDetails.map((detail, i) => 
                    i === index ? { ...detail, ...updatedDetail } : detail
                )
            }]
        }));
    } else {
        // With visit profiles
        setFormValues((prevValues) => ({
            ...prevValues,
            employeePlanDates: prevValues.employeePlanDates.map(planDate => 
                planDate.visitProfileId === activeVisitProfileId
                    ? {
                        ...planDate,
                        planDetails: planDate.planDetails.map((detail, i) => 
                            i === index ? { ...detail, ...updatedDetail } : detail
                        )
                    }
                    : planDate
            )
        }));
    }
    setDisable(false);
    setErrors([]);
};

  const validatePlanDetails = () => {
    const newErrors = [];
    
    const activePlanDate = formValues.employeePlanDates.find(pd => pd.visitProfileId === activeVisitProfileId);
    
    if (!activePlanDate) {
        return false;
    }

    if (activePlanDate.onLeave) {
        if (!activePlanDate.leaveMessage || activePlanDate.leaveMessage.trim() === "") {
            setErrors([{ leaveMessage: 'Leave message is required when on leave' }]);
            return false;
        }
        setErrors([]);
        return true;
    }

    if (formValues.employeePlanId !== 0) {
        const planDetails = activePlanDate.planDetails;
        const allDetailsEmpty = planDetails.every(detail =>
            !detail.practiceLocationId &&
            !detail.doctorId &&
            !detail.startTime &&
            !detail.endTime &&
            (!detail.cityId || detail.cityId === null) &&
            !detail.headOffice
        );

        if (allDetailsEmpty) {
            return true;
        }
    }
    
    const planDetails = activePlanDate.planDetails;

    planDetails.forEach((detail, index) => {
        const detailErrors = {};

        if (permissions && permissions.includes('CanAddPlannerLocation') && !detail.practiceLocationId) {
            detailErrors.practiceLocationId = 'Practice Location is required';
        }
        if (permissions && permissions.includes('CanAddPlannerDoctor') && !detail.doctorId) {
            detailErrors.doctorId = 'Doctor is required';
        }
        if (permissions && permissions.includes('CanAddPlannerTime') && !detail.startTime) {
            detailErrors.startTime = 'Start time is required';
        }
        if (permissions && permissions.includes('CanAddPlannerTime') && !detail.endTime) {
            detailErrors.endTime = 'End time is required';
        }
        if (permissions && permissions.includes('CanAddPlannerTime') && detail.startTime && detail.endTime && detail.startTime >= detail.endTime) {
            detailErrors.endTime = 'End time invalid';
        }
        if (permissions && permissions.includes('CanAddPlannerCity') && !detail.cityId && !detail.headOffice) {
            detailErrors.cityId = 'City is required';
        }

        // Validate Products, SubTasks, and Priority (for full planner users)
        if (permissions && permissions.includes('CanAddPlannerTime')) {
            if (!detail.products || detail.products.length === 0) {
                detailErrors.products = 'At least one product is required';
            }
            if (!detail.subTasks || detail.subTasks.length === 0) {
                detailErrors.subTasks = 'At least one sub task is required';
            }
            if (!detail.priority && detail.priority !== 0) {
                detailErrors.priority = 'Priority is required';
            }
        }

        planDetails.forEach((otherDetail, otherIndex) => {
            if (index !== otherIndex && otherDetail.startTime && otherDetail.endTime) {
                const otherStart = otherDetail.startTime;
                const otherEnd = otherDetail.endTime;

                if (detail.startTime >= otherStart && detail.startTime < otherEnd) {
                    detailErrors.startTime = 'Start time overlap';
                }

                if (detail.endTime > otherStart && detail.endTime <= otherEnd) {
                    detailErrors.endTime = 'End time overlap';
                }

                if (detail.startTime <= otherStart && detail.endTime >= otherEnd) {
                    detailErrors.startTime = 'Start time overlap';
                    detailErrors.endTime = 'End time overlap';
                }
            }
        });

        if (Object.keys(detailErrors).length > 0) {
            newErrors[index] = detailErrors;
        }
    });

    setErrors(newErrors);
    return newErrors.length === 0;
};
 const handleSave = () => {
    if (validatePlanDetails()) {
        const user = JSON.parse(localStorage.getItem("user"));
        const userId = user?.result[0]?.user.id;
        
        const activePlanDate = formValues.employeePlanDates.find(pd => pd.visitProfileId === activeVisitProfileId);
        
        if (!activePlanDate) {
            console.error("No active plan date found");
            return;
        }

        const hasVisitProfiles = userDetail?.visitProfiles && userDetail.visitProfiles.length > 0;
        const isUpdate = formValues.employeePlanId && formValues.employeePlanId !== 0;
        
        // Check if the date is marked as on leave
        const isOnLeave = activePlanDate.onLeave;
        
        // Find the correct employeePlanDateId
        // For updates: find the first planDate with a valid employeePlanDateId (> 0)
        // For new plans: use 0
        let employeePlanDateId = 0;
        
        if (isUpdate) {
            // Find any planDate that has an actual ID from the database
            const existingPlanDate = formValues.employeePlanDates.find(pd => 
                pd.employeePlanDateId && pd.employeePlanDateId > 0
            );
            
            if (existingPlanDate) {
                employeePlanDateId = existingPlanDate.employeePlanDateId;
            } else {
                // This is an update but we don't have an employeePlanDateId
                // This means we're adding a new date to an existing plan
                employeePlanDateId = 0;
            }
        }
        
        let payload;
        
        if (isOnLeave) {
            // ON LEAVE: Don't send any visit profiles or plan details
            payload = {
                employeePlanId: formValues.employeePlanId || 0,
                employeeId: userId,
                month: formValues.month,
                year: formValues.year,
                employeePlanDate: {
                    employeePlanDateId: employeePlanDateId,
                    planDate: activePlanDate.planDate,
                    onLeave: true,
                    leaveMessage: activePlanDate.leaveMessage,
                    visitProfiles: [],
                    planDetails: []
                }
            };
        }else if (hasVisitProfiles) {
    // User has visit profiles - collect ONLY visit profiles that have actual plan details
    const visitProfilesData = formValues.employeePlanDates
        .filter(planDate => planDate.visitProfileId)
        .map(planDate => {
            const cleanedPlanDetails = planDate.planDetails
                .filter(detail => {
                    // Check if user can select city/head office
                    const canSelectCityOrHeadOffice = permissions && 
                        permissions.includes('CanAddPlannerCity') && 
                        !permissions.includes('CanAddPlannerTime');
                    
                    // If user is editing an existing plan detail (has an ID) and can select city/head office,
                    // keep it even if all fields are empty (this represents clearing/deleting the plan)
                    if (canSelectCityOrHeadOffice && detail.id && detail.id !== 0) {
                        return true;
                    }
                    
                    // Otherwise, filter out completely empty details
                    return detail.practiceLocationId ||
                        detail.doctorId ||
                        detail.startTime ||
                        detail.endTime ||
                        detail.headOffice;
                })
                .map(detail => ({
                    id: detail.id || 0,
                    cityId: detail.cityId || null,
                    startTime: detail.startTime || null,
                    endTime: detail.endTime || null,
                    practiceLocationId: detail.practiceLocationId || null,
                    doctorId: detail.doctorId || null,
                    headOffice: detail.headOffice || false,
                    productIds: detail.products || [],
                    subTaskIds: detail.subTasks || [],
                    priority: detail.priority || null,
                    accompaniedByIds: detail.accompaniedByIds || [],
                    assignedTo: userId
                }));
            
            return {
                visitProfileId: planDate.visitProfileId,
                planDetails: cleanedPlanDetails
            };
        })
        .filter(vp => vp.planDetails.length > 0); // ✅ FILTER OUT empty visit profiles
    
    // Don't send the payload if there are no visit profiles with plan details
    if (visitProfilesData.length === 0) {
        console.log("No visit profiles with plan details to save");
        return;
    }

    payload = {
        employeePlanId: formValues.employeePlanId || 0,
        employeeId: userId,
        month: formValues.month,
        year: formValues.year,
        employeePlanDate: {
            employeePlanDateId: employeePlanDateId,
            planDate: activePlanDate.planDate,
            onLeave: false,
            leaveMessage: "",
            visitProfiles: visitProfilesData,
            planDetails: []
        }
    };
}else {
            const cleanedPlanDetails = activePlanDate.planDetails
                .filter(detail => {
                    // Check if user can select city/head office
                    const canSelectCityOrHeadOffice = permissions && 
                        permissions.includes('CanAddPlannerCity') && 
                        !permissions.includes('CanAddPlannerTime');
                    
                    // If user is editing an existing plan detail (has an ID) and can select city/head office,
                    // keep it even if all fields are empty (this represents clearing/deleting the plan)
                    if (canSelectCityOrHeadOffice && detail.id && detail.id !== 0) {
                        return true;
                    }
                    
                    // Otherwise, filter out completely empty details
                    return detail.practiceLocationId ||
                        detail.doctorId ||
                        detail.startTime ||
                        detail.endTime ||
                        detail.cityId ||
                        detail.headOffice;
                })
                .map(detail => ({
                    id: detail.id || 0,
                    cityId: detail.cityId || null,
                    startTime: detail.startTime || null,
                    endTime: detail.endTime || null,
                    practiceLocationId: detail.practiceLocationId || null,
                    doctorId: detail.doctorId || null,
                    headOffice: detail.headOffice || false,
                    productIds: detail.products || [],
                    subTaskIds: detail.subTasks || [],
                    priority: detail.priority || null,
                    accompaniedByIds: detail.accompaniedByIds || [],
                    assignedTo: userId
                }));
                
            payload = {
                employeePlanId: formValues.employeePlanId || 0,
                employeeId: userId,
                month: formValues.month,
                year: formValues.year,
                employeePlanDate: {
                    employeePlanDateId: employeePlanDateId,
                    planDate: activePlanDate.planDate,
                    onLeave: false,
                    leaveMessage: "",
                    visitProfiles: [],
                    planDetails: cleanedPlanDetails
                }
            };
        }

        setIsSaving(true);

        if (payload.employeePlanId && payload.employeePlanId !== 0) {
            console.log("Updating plan:", payload);
            dispatch(updateEmployeePlan(payload));
        } else {
            console.log("Adding new plan:", payload);
            dispatch(addEmployeePlan(payload));
        }
    }
};
// NEW CODE
const handleClose = () => {
    setFormValues(initialValues);
    setErrors([]);
    setUpdatedFormValues([]);
    setDeletePlanDetail([]);
    setIsDeleteActive(false);
    setVisitProfilePlanDetails({}); 
    setIsLoadingVisitProfile(false);
    setLoadedVisitProfiles(new Set());
    setActiveVisitProfileId(null);
    setVisitProfileId(null);
    setIsVisitProfileId(false);
    onClose();
};
useEffect(() => {
    // Reset state when drawer closes
    if (!isOpen) {
        setFormValues(initialValues);
        setErrors([]);
        setUpdatedFormValues([]);
        setDeletePlanDetail([]);
        setIsDeleteActive(false);
        setVisitProfilePlanDetails({}); 
        setIsLoadingVisitProfile(false);
        setLoadedVisitProfiles(new Set());
        setActiveVisitProfileId(null);
        setVisitProfileId(null);
        setIsVisitProfileId(false);
    }
}, [isOpen]);
    useEffect(() => {
    if ((addPlanStatus && addPlanStatus !== "isLoading" && addPlanStatus === true) || (updateEmployeePlanStatus && updateEmployeePlanStatus !== "isLoading" && updateEmployeePlanStatus === true)) {
        setIsSaving(false); 
        handleClose();
        setIsDeleteVisitModalVisisble(false);
        setDeletePlanDetail([]);
        setIsDeleteActive(false);
    }
}, [addPlanStatus, updateEmployeePlanStatus]);

    useEffect(() => {
        if (deletePlanVisitsStatus && deletePlanVisitsStatus !== "isLoading" && deletePlanVisitsStatus === true) {
            setFormValues(updatedFormValues);
            setIsDeleteVisitModalVisisble(false);
            setIsDeleteActive(false);
            setDeletePlanDetail([]);
            handleClose();
        }
    }, [deletePlanVisitsStatus]);

    useEffect(() => {
        if (userId) {
            dispatch(getEmployee(userId));
            dispatch(getTaskLookup(userId));
        }
        if (permissions && permissions.includes('CanAddPlannerCity')) {
            const cityBody = {
                filter: {
                    textSearch: "",
                    countryId: "1"
                },
                pageNumber: -1,
                pageSize: 0,
            };
            dispatch(getCities(cityBody));
        }
    }, [userId]);
   // NEW CODE
const handleSelectChange = (event, fieldName) => {
    if (fieldName === 'visitProfileId') {
        const newVisitProfileId = event.value;
        
        // Switch the active visit profile
        setActiveVisitProfileId(newVisitProfileId);
        setVisitProfileId(newVisitProfileId);
        setIsVisitProfileId(true);
        
        // Always fetch visit profile details when switching tabs
        // This ensures the city name is always available
        if (!loadedVisitProfiles.has(newVisitProfileId)) {
            setIsLoadingVisitProfile(true);
            dispatch(getVisitProfileDetail(newVisitProfileId));
        }
    }
};

    const applyVisitProfileChange = (selectedVisitProfileId) => {
    setVisitProfileId(selectedVisitProfileId);
    setIsVisitProfileId(selectedVisitProfileId ? true : false);

    // Check if we have saved plan details for this visit profile
    const savedPlanDetails = visitProfilePlanDetails[selectedVisitProfileId];
    const hasSavedData = savedPlanDetails && savedPlanDetails.length > 0;

    // Only fetch and show loading if visiting this profile for the first time
    if (selectedVisitProfileId && !hasSavedData) {
        setIsLoadingVisitProfile(true);
        dispatch(getVisitProfileDetail(selectedVisitProfileId));
    }

    const emptyPlanDetail = {
    id: 0,
    cityId: null,
    startTime: null,
    endTime: null,
    practiceLocationId: null,
    doctorId: null,
    headOffice: false,
    products: [],
    subTasks: [],
    priority: null,
    accompaniedByIds: []
};

    // Use saved plan details if available, otherwise use empty plan detail
    const planDetailsToUse = hasSavedData ? savedPlanDetails : [emptyPlanDetail];

    setFormValues(prevValues => ({
        ...prevValues,
        employeePlanDate: {
            ...prevValues.employeePlanDate,
            visitProfileId: selectedVisitProfileId,
            planDetails: prevValues.employeePlanDate.onLeave ? [] : planDetailsToUse
        },
    }));

    setDisable(false);
};
    const closeVisitProfileModal = () => {
        setIsVisitProfileModalVisible(false);
        setVisitProfileChange(null);
    };

    const confirmVisitProfileChange = () => {
    if (VisitProfileChange !== null) {
        // Store current plan details before confirming change
        if (formValues.employeePlanDate.visitProfileId) {
            setVisitProfilePlanDetails(prev => ({
                ...prev,
                [formValues.employeePlanDate.visitProfileId]: formValues.employeePlanDate.planDetails
            }));
        }
        applyVisitProfileChange(VisitProfileChange);
    }
    setIsVisitProfileModalVisible(false);
    setVisitProfileChange(null);
};
    const getOptions = (fieldName) => {
        if (fieldName === 'visitProfileId') {
            const visitProfiles = userDetail?.visitProfiles || user?.result[0]?.user?.visitProfiles || [];
            return visitProfiles.map(profile => ({
                value: profile.visitProfileId,
                label: profile.profileName
            }));
        }
        return [];
    };

    const onDeleteVisitModalClose = () => {
        setIsDeleteVisitModalVisisble(!isDeleteVisitModalVisible);
    };

    const handleToggleCheckbox = (index, isChecked) => {
        setDeletePlanDetail((prevState) => {
            if (isChecked) {
                return [...prevState, index];
            } else {
                return prevState.filter((item) => item !== index);
            }
        });
    };
    const handleDeleteConfirm = async () => {
    if (deletePlanVisitsIds && deletePlanVisitsIds.length !== 0) {
        const body = {
            "planDetailIds": deletePlanVisitsIds,
            "employeeId": userId
        }
        await dispatch(deletePlanVisits(body));
    } else if (updatedFormValues && updatedFormValues.length !== 0) {
        setFormValues(updatedFormValues);
        setIsDeleteVisitModalVisisble(false);
        setIsDeleteActive(false);
        setDeletePlanDetail([]);
    }
};
   // OLD CODE - FIND THIS:
const handleDelete = () => {
    if (deletePlanDetail.length > 0) {
        const activePlanDate = formValues.employeePlanDates.find(pd => pd.visitProfileId === activeVisitProfileId);
        
        if (activePlanDate && activePlanDate.planDetails) {
            const deletePlanVisitsIds = [];
            activePlanDate.planDetails.forEach((item, index) => {
                if (deletePlanDetail.includes(index) && item.id !== null && item.id !== 0) {
                    deletePlanVisitsIds.push(item.id);
                }
            });
            
            const updatedPlanDetails = activePlanDate.planDetails.filter(
                (_, index) => !deletePlanDetail.includes(index)
            );
            
            const updatedPlanDates = formValues.employeePlanDates.map(planDate => 
                planDate.visitProfileId === activeVisitProfileId
                    ? {
                        ...planDate,
                        employeePlanDateId: updatedPlanDetails.length === 0 ? 0 : planDate.employeePlanDateId,
                        planDetails: updatedPlanDetails
                    }
                    : planDate
            );

            setUpdatedFormValues({
                ...formValues,
                employeePlanId: updatedPlanDetails.length === 0 ? 0 : formValues.employeePlanId,
                employeePlanDates: updatedPlanDates
            });
            
            setDeletePlanVisitsIds(deletePlanVisitsIds);
            setIsDeleteVisitModalVisisble(true);
        }
    }
};

    useEffect(() => {
        if (userDetail && userDetail !== "isLoading" && userDetail.length !== 0) {
            if (userDetail && userDetail.visitProfiles.length !== 0) {
                setIsVisitProfileId(true);
            }
        }
    }, [userDetail]);
    
useEffect(() => {
    if (isVisitProfileId && visitProfileId && visitProfileDetail && 
        visitProfileDetail !== "isLoading" && visitProfileDetail.result?.[0]) {
        
        const profileCityId = visitProfileDetail.result[0]?.cityId;
        
        if (profileCityId && activeVisitProfileId === visitProfileId) {
            if (!loadedVisitProfiles.has(visitProfileId)) {
                setFormValues(prevValues => ({
                    ...prevValues,
                    employeePlanDates: prevValues.employeePlanDates.map(planDate => 
                        planDate.visitProfileId === visitProfileId
                            ? {
                                ...planDate,
                                planDetails: planDate.planDetails.map(detail => {
                                    // Only set cityId if it's not already set (for new plans)
                                    // For existing plans, keep the existing values
                                    const shouldSetCity = !detail.cityId && !detail.practiceLocationId && !detail.doctorId && detail.id === 0;
                                    
                                   return {
                                        ...detail,
                                        cityId: shouldSetCity ? profileCityId : (detail.cityId || null),
                                    };
                                })
                            }
                            : planDate
                    )
                }));
                
                setLoadedVisitProfiles(prev => new Set([...prev, visitProfileId]));
            }
            
            setIsLoadingVisitProfile(false);
        }
    } else if (visitProfileDetail === "isLoading") {
        setIsLoadingVisitProfile(true);
    }
}, [visitProfileDetail, visitProfileId, isVisitProfileId, activeVisitProfileId, loadedVisitProfiles]);
useEffect(() => {
    if (permissions && permissions.includes('CanAddPlannerCity') && permissions.includes('CanAddPlannerLocation')) {
        const activePlanDate = formValues.employeePlanDates.find(pd => pd.visitProfileId === activeVisitProfileId);
        
        if (activePlanDate) {
            activePlanDate.planDetails.forEach((planDetail) => {
                if (planDetail.cityId && planDetail.cityId !== "clear") {
                    setIsPracticeLocationsLoading(true);
                    dispatch(getTaskPracticeLocations(planDetail.cityId));
                }
            });
        }
    }
}, [
    activeVisitProfileId, 
    // Only track city changes, not all form changes
    formValues.employeePlanDates.map(pd => 
        pd.visitProfileId === activeVisitProfileId 
            ? pd.planDetails.map(detail => detail.cityId).join(',') 
            : ''
    ).join('|')
]);
// NEW CODE:
const getActivePlanDate = () => {
    // If no visit profiles, return the first (and only) plan date
    if (!isVisitProfileId && formValues.employeePlanDates.length > 0) {
        return formValues.employeePlanDates[0];
    }
    
    // With visit profiles, find the active one
    const activePlanDate = formValues.employeePlanDates.find(pd => pd.visitProfileId === activeVisitProfileId);
    
    if (activePlanDate) {
        return activePlanDate;
    }
    
    // Return default empty state if no active plan date found
    return {
        employeePlanDateId: 0,
        planDate: null,
        visitProfileId: activeVisitProfileId,
        onLeave: false,
        leaveMessage: "",
        planDetails: []
    };
};
// DEBUG LOGGING - Remove after fixing
console.log('AddDrawer Debug:', {
    activeVisitProfileId,
    activePlanDate: getActivePlanDate(),
    formValues: formValues.employeePlanDates,
    events,
    loadedVisitProfiles: Array.from(loadedVisitProfiles)
});
    return (
        <>
            <div
                className={`add-drawer-backdrop ${isOpen ? 'open' : ''}`}
                onClick={handleClose}
            ></div>

            <div className={`add-drawer-container ${isOpen ? 'open' : ''}`}>
    <LoadingOverlay isVisible={isSaving || isLoadingVisitProfile} />
                <div className="add-drawer-header">
                    <BodyLargeMedium text={formattedDate} color='#384153' />
                    <button
disabled={
    addPlanStatus === "isLoading" || 
    updateEmployeePlanStatus === "isLoading" || 
    (!getActivePlanDate().onLeave && 
        (getActivePlanDate()?.planDetails?.length === 0 || 
         getActivePlanDate()?.planDetails?.every(detail => {
            // For users who can select city/head office only (no time permission)
            // Allow saving even when cityId is null (when "None" is selected)
            const canSelectCityOrHeadOffice = permissions && 
                permissions.includes('CanAddPlannerCity') && 
                !permissions.includes('CanAddPlannerTime');
            
            const isAllFieldsEmpty = !detail.practiceLocationId &&
                !detail.doctorId &&
                !detail.startTime &&
                !detail.endTime &&
                !detail.cityId &&
                !detail.headOffice;
            
            // If user can select city/head office and has an existing plan being edited,
            // allow saving even if fields are empty (clearing/deleting plan)
            if (canSelectCityOrHeadOffice && formValues.employeePlanId && formValues.employeePlanId !== 0) {
                return false; // Don't disable save
            }
            
            return isAllFieldsEmpty;
         })
        )
    ) ||
    (getActivePlanDate().onLeave && !getActivePlanDate().leaveMessage?.trim())
}    className={`save-button ${disable ? 'disabled' : ''}`}
    onClick={handleSave}
    style={document.body.dir === "rtl" ? { width: '123px' } : {}}
>
                        <img src={tickIcon} alt="tick icon" />
                         <Heading6Regular text={t("save")} color="#FFFFFF" />
                    </button>
                    {(permissions && !permissions.includes('CanAddPlannerTime')) || isDeleteActive && (
                        <button className='close-icon-button' onClick={() => setIsDeleteActive(false)}>
                            <img src={closeIcon} />
                        </button>
                    )}
                    {permissions && permissions.includes('CanAddPlannerLocation') && permissions.includes('CanAddPlannerTime') && !isDeleteActive && (
                        <button className='delete-icon-button' onClick={() => setIsDeleteActive(true)}>
                            <img src={deleteIcon_drawer} />
                        </button>
                    )}
                </div>
                <div className='add-drawer-main'>
    <div className='on-leave-row' style={{ margin: '16px 0' }}>
        <input
    type="checkbox"
    className='on-leave-checkbox'
    checked={getActivePlanDate().onLeave}
    onChange={handleOnLeaveChange}
/>
        <BodySmallMedium text={t("onLeave")} color="#6B7280" />
    </div>

    {getActivePlanDate().onLeave && (
    <div className="leave-message-container">
        <Textarea
            height='85px'
            width='250px'
            name="leaveMessage"
            label={t("leaveMessage")}
            placeholder={t("enterLeaveMessage")}
            value={getActivePlanDate().leaveMessage}
            onChange={handleLeaveMessageChange}
            error={errors[0]?.leaveMessage}
        />
        <div className="character-counter">
            {getActivePlanDate().leaveMessage.length}/150
        </div>
    </div>
)}

    {isVisitProfileId && (
    <div className="visit-profile-tabs-container">
<div className="visit-profile-label">
            <img src={visitProfileIcon} alt="visit profile icon" />
            <BodySmallMedium text={t("Visit Profiles")} color='#1E293B' />
        </div>       <div className="tabs-header">
    {getOptions("visitProfileId").map((profile) => (
        <button
            key={profile.value}
            className={`tab-button ${activeVisitProfileId === profile.value ? 'active' : ''}`}
            onClick={() => {
                const event = { value: profile.value };
                handleSelectChange(event, 'visitProfileId');
            }}
            disabled={getActivePlanDate().onLeave}
        >
            {profile.label}
        </button>
    ))}
</div>
    </div>
)}

                    <VisitProfileModal
                        isVisible={isVisitProfileModalVisible}
                        onClose={closeVisitProfileModal}
                        onConfirm={confirmVisitProfileChange}
                        isLoading={false}
                    />

                    {getActivePlanDate().planDetails.map((planDetail, index) => (
    <AddEventCard
        key={index}
        isDeleteActive={isDeleteActive}
        planDetail={planDetail}
        practiceLocations={practiceLocations}
        isVisitProfileId={isVisitProfileId}
        onUpdatePlanDetail={updatePlanDetail}
        index={index}
        errors={errors[index] || {}}
        formValues={formValues}
        activeVisitProfileId={activeVisitProfileId}
        isChecked={deletePlanDetail.includes(index)}
        onToggleCheckbox={handleToggleCheckbox}
        isOnLeave={getActivePlanDate().onLeave}
        isPracticeLocationsLoading={isPracticeLocationsLoading}
        taskLookups={taskLookups}
        taskLookupsLoading={taskLookupsLoading}
    />
))}

                    {((formValues.employeePlanId && formValues.employeePlanId !== 0) || !getActivePlanDate().onLeave) && permissions && permissions.includes('CanAddPlannerTime') && permissions.includes('CanAddPlannerLocation') && !isDeleteActive && (
    <button className='add-another-button' onClick={addAnotherPlanDetail}>
        <img src={addIcon} />
        <Heading6Regular text={t("addAnother")} color='#1E293B' />
    </button>
)}
                </div>
                {isDeleteActive && (
                    <div className='footer-button-container'>
                        <button className='cancel-button'
                            onClick={() => {
                                setIsDeleteActive(false);
                                setDeletePlanDetail([]);
                            }}
                        >
                            <span style={{color: '#1E293B', fontSize: '16px', fontWeight: 400}}>Cancel</span>
                        </button>
                        <button
                            className={`delete-button ${deletePlanDetail.length === 0 ? 'opacity-70 cursor-not-allowed' : ''}`}
                            onClick={handleDelete} disabled={deletePlanDetail.length === 0}>
                            <span style={{color: '#FFFFFF', fontSize: '16px', fontWeight: 400}}>Delete</span>
                        </button>
                    </div>
                )}
            </div>
            <DeleteVisitModal isLoading={deletePlanVisitsStatus === "isLoading"} onDeleteClick={handleDeleteConfirm} isVisible={isDeleteVisitModalVisible} onClose={onDeleteVisitModalClose} />
        </>
    );
};

export default AddDrawer;